import {
  Alert,
  AlertTitle,
  Autocomplete,
  Box,
  Button,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Radio,
  RadioGroup,
  Snackbar,
  TextField,
} from "@mui/material";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GET_LOGGED_IN_USER_RESET,
  RESET_PASSWORD_RESET,
  UPDATE_USER_RESET,
} from "../Constants/Constants";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import {
  getAllCountry,
  getLoggedInUser,
  resetPassword,
  updateUser,
} from "../redux/actions/AdminAction";

export default function AdminProfile() {
  const dispatch = useDispatch();

  const user_id = JSON.parse(localStorage.getItem("user_id"));
  const token = JSON.parse(localStorage.getItem("userInfo"));

  const [role, setRole] = React.useState("");
  const [first_name, setFirst_name] = React.useState("");
  const [last_name, setLast_name] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [emailError, setEmailError] = React.useState("");
  const [contact_number, setContact_number] = React.useState("");
  const [contact_number_error, setContact_number_error] = React.useState("");

  const [current_password, setCurrent_password] = React.useState("");
  const [new_password, setNew_password] = React.useState("");
  const [confirm_password, setConfirm_password] = React.useState("");

  const [showCurrentPassword, setShowCurrentPassword] = React.useState(false);
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const [errorAlert, setErrorAlert] = React.useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = React.useState("");
  const [errorAlertTitle, setErrorAlertTitle] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [selectedCountries, setSelectedCountries] = React.useState([]);
  const [is_all_countries, setIs_all_countries] = React.useState("");

  const GetLoggedInUser = useSelector((state) => state.GetLoggedInUser);
  const { loggedInUserInfo } = GetLoggedInUser;

  const UpdateUser = useSelector((state) => state.UpdateUser);
  const {
    success: updateUserSuccess,
    message: updateUserMessage,
    updateUserError,
  } = UpdateUser;

  const ResetUserPassword = useSelector((state) => state.ResetUserPassword);
  const {
    success: resetPasswordSuccess,
    message: resetPasswordMessage,
    resetPasswordError,
  } = ResetUserPassword;

  const GetAllCountry = useSelector((state) => state.GetAllCountry);
  const { countryInfo } = GetAllCountry;

  React.useEffect(() => {
    dispatch({ type: GET_LOGGED_IN_USER_RESET });
    dispatch({ type: UPDATE_USER_RESET });
    dispatch(getLoggedInUser(user_id));
    dispatch(getAllCountry());
  }, []);

  React.useEffect(() => {
    if (loggedInUserInfo) {
      setRole(loggedInUserInfo?.role?.trim() || "");
      setFirst_name(loggedInUserInfo?.first_name?.trim() || "");
      setLast_name(loggedInUserInfo?.last_name?.trim() || "");
      setEmail(loggedInUserInfo?.email?.trim() || "");
      setContact_number(loggedInUserInfo?.contact_number?.trim() || "");
      setSelectedCountries(loggedInUserInfo?.selected_countries || []);
      setIs_all_countries(
        loggedInUserInfo?.is_all_countries === null ||
          loggedInUserInfo?.is_all_countries === undefined
          ? "all"
          : loggedInUserInfo?.is_all_countries
          ? "all"
          : "multiple"
      );
    }
  }, [loggedInUserInfo]);

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen(false);
    setErrorAlert(false);
  };

  const validateEmail = (email) => {
    // Basic email validation regex
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleClickShowCurrentPassword = () =>
    setShowCurrentPassword((show) => !show);

  const handleClickShowNewPassword = () => setShowNewPassword((show) => !show);

  const handleClickConfirmPassword = () =>
    setShowConfirmPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleEmail = (event) => {
    const enteredEmail = event.target.value;

    const invalidEmail = !validateEmail(enteredEmail);

    if (invalidEmail) {
      setEmailError("Invalid email address");
    } else {
      setEmailError("");
    }

    setEmail(enteredEmail);
  };

  const validateContactNumber = (number) => {
    // Validation: Allow numbers with or without + and country code
    // Option 1: + followed by 10-15 digits
    // Option 2: 10-15 digits
    const regex = /^(?:\+\d{1,3})?\d{10,15}$/;
    return regex.test(number);
  };

  const handleContactNumber = (e) => {
    const number = e.target.value;

    // Allow only valid characters: digits and +
    if (/^[+\d]*$/.test(number)) {
      setContact_number(number);

      if (number && !validateContactNumber(number)) {
        setContact_number_error(
          "Telephone number should be 10-15 digits, with or without a leading + and country code."
        );
      } else {
        setContact_number_error("");
      }
    }
  };

  const updateUserHandler = () => {
    dispatch({ type: RESET_PASSWORD_RESET });
    if (emailError || contact_number_error) {
      dispatch({ type: UPDATE_USER_RESET });
      dispatch({ type: RESET_PASSWORD_RESET });
      setErrorAlertTitle("Invalid values in the field.");
      setErrorAlertMessage("Please enter the fields properly.");
      setErrorAlert(true);
      setSnackOpen(true);
      return;
    }
    if (first_name && email) {
      const user = {
        first_name: first_name?.trim(),
        last_name: last_name?.trim(),
        email: email?.trim(),
        contact_number: contact_number?.trim(),
      };
      dispatch(updateUser(user_id, user));
      setSnackOpen(true);
    } else {
      dispatch({ type: UPDATE_USER_RESET });
      dispatch({ type: RESET_PASSWORD_RESET });
      setErrorAlertTitle("Required field error");
      setErrorAlertMessage(
        "Please enter all the fields. First name and email are required."
      );
      setSnackOpen(true);
      setErrorAlert(true);
    }
  };

  const resetPasswordHandler = () => {
    if (current_password) {
      if (new_password != confirm_password) {
        dispatch({ type: UPDATE_USER_RESET });
        dispatch({ type: RESET_PASSWORD_RESET });
        setErrorAlertTitle("Filed don't match");
        setErrorAlertMessage(
          "New password and confirm password don't match! Enter confirm password again"
        );
        setSnackOpen(true);
        setErrorAlert(true);
      } else {
        const user = {
          current_password: current_password?.trim(),
          new_password: new_password?.trim(),
        };
        dispatch(resetPassword(user_id, user));
        setSnackOpen(true);
        setTimeout(() => {
          setCurrent_password("");
          setNew_password("");
          setConfirm_password("");
        }, 5000);
      }
    } else {
      dispatch({ type: UPDATE_USER_RESET });
      dispatch({ type: RESET_PASSWORD_RESET });
      setErrorAlertTitle("Required field error");
      setErrorAlertMessage("Please enter the current password");
      setSnackOpen(true);
      setErrorAlert(true);
    }
  };

  return (
    <Container sx={{ marginBottom: "5%" }}>
      <Box sx={{ margin: 3, fontSize: 25 }}>
        User Profile
        <Divider sx={{ marginTop: 2 }}></Divider>
      </Box>
      <Box sx={{ fontSize: 25, margin: 3 }}>My Profile</Box>
      <Box sx={{ margin: 3, marginTop: 5 }}>
        <Box sx={{ fontSize: 20 }}>
          Edit Profile<Divider sx={{ marginTop: 2 }}></Divider>
        </Box>
        <Grid container sx={{ marginTop: 3 }}>
          <Grid item xs={12}>
            <FormControl disabled>
              <FormLabel sx={{ color: "black !important" }}>Role</FormLabel>
              <RadioGroup
                row
                defaultValue={role}
                value={role}
                onChange={(e) => setRole(e.target.value)}
              >
                <FormControlLabel
                  value="user"
                  control={<Radio />}
                  label="User"
                />
                <FormControlLabel
                  value="admin"
                  control={<Radio />}
                  label="Admin"
                />
                <FormControlLabel
                  value="superuser"
                  control={<Radio />}
                  label="Superuser"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12} mt={2}>
            <Grid item xs={6}>
              First name
            </Grid>
            <Grid item xs={6} mt={1}>
              <TextField
                fullWidth
                required
                value={first_name}
                onChange={(e) => setFirst_name(e.target.value)}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} mt={2}>
            <Grid item xs={6}>
              Last name
            </Grid>
            <Grid item xs={6} mt={1}>
              <TextField
                fullWidth
                required
                value={last_name}
                onChange={(e) => setLast_name(e.target.value)}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} mt={2}>
            <Grid item xs={6}>
              Email
            </Grid>
            <Grid item xs={6} mt={1}>
              <TextField
                fullWidth
                required
                value={email}
                onChange={handleEmail}
                error={!!emailError}
                helperText={emailError}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} mt={2}>
            <Grid item xs={6}>
              Contact number
            </Grid>
            <Grid item xs={6} mt={1}>
              <TextField
                fullWidth
                required
                value={contact_number}
                onChange={handleContactNumber}
                error={!!contact_number_error}
                helperText={contact_number_error}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} mt={2}>
            <Grid item xs={6}>
              Country
            </Grid>
            <Grid item xs={6} mt={1}>
              {is_all_countries === "all" ? (
                <TextField
                  fullWidth
                  disabled
                  value="Permission granted to all countries"
                  variant="outlined"
                />
              ) : (
                <Autocomplete
                  disabled
                  fullWidth
                  multiple
                  options={
                    countryInfo?.filter(
                      (country) =>
                        !selectedCountries.includes(country.country_code.trim())
                    ) || []
                  }
                  getOptionLabel={(option) => option.name.trim()}
                  value={
                    selectedCountries
                      ?.map((selected) =>
                        countryInfo?.find(
                          (country) =>
                            country?.country_code?.trim() === selected
                        )
                      )
                      .filter(Boolean) || []
                  }
                  onChange={(event, newValue) => {
                    const selectedCodes = newValue.map((country) =>
                      country.country_code.trim()
                    );
                    setSelectedCountries(selectedCodes);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" />
                  )}
                />
              )}
            </Grid>
          </Grid>
          <Grid item xs={12} mt={2}>
            <Button
              variant="contained"
              type="submit"
              sx={{ backgroundColor: "#282828" }}
              onClick={updateUserHandler}
            >
              Save
            </Button>
          </Grid>
        </Grid>
        <Box sx={{ marginTop: 6 }}>
          <Box sx={{ fontSize: 20 }}>
            Change password<Divider sx={{ marginTop: 2 }}></Divider>
          </Box>
          <Grid container sx={{ marginTop: 3 }}>
            <Grid item xs={12}>
              <Grid item xs={6}>
                Current password
              </Grid>
              <Grid item xs={6} mt={1}>
                <FormControl variant="outlined" size="medium" fullWidth>
                  <OutlinedInput
                    required
                    fullWidth
                    type={showCurrentPassword ? "text" : "password"}
                    value={current_password}
                    onChange={(e) => setCurrent_password(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowCurrentPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showCurrentPassword ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid item xs={12} mt={2}>
              <Grid item xs={6}>
                New password
              </Grid>
              <Grid item xs={6} mt={1}>
                <FormControl variant="outlined" size="medium" fullWidth>
                  <OutlinedInput
                    required
                    fullWidth
                    type={showNewPassword ? "text" : "password"}
                    value={new_password}
                    onChange={(e) => setNew_password(e.target.value)}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowNewPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showNewPassword ? (
                            <VisibilityOffIcon />
                          ) : (
                            <VisibilityIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} mt={2}>
                <Grid item xs={6}>
                  Confirm new password
                </Grid>
                <Grid item xs={6} mt={1}>
                  <FormControl variant="outlined" size="medium" fullWidth>
                    <OutlinedInput
                      required
                      fullWidth
                      type={showConfirmPassword ? "text" : "password"}
                      value={confirm_password}
                      onChange={(e) => setConfirm_password(e.target.value)}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleClickConfirmPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showConfirmPassword ? (
                              <VisibilityOffIcon />
                            ) : (
                              <VisibilityIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </Grid>
              </Grid>
              <Grid item xs={12} mt={2}>
                <Button
                  variant="contained"
                  type="submit"
                  sx={{ backgroundColor: "#282828" }}
                  onClick={resetPasswordHandler}
                >
                  Update Password
                </Button>
              </Grid>
            </Grid>
          </Grid>
          {errorAlert && (
            <Snackbar
              open={snackOpen}
              autoHideDuration={5000}
              onClose={handleSnackClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              sx={{ width: "20%" }}
            >
              <Alert
                onClose={handleSnackClose}
                severity="error"
                sx={{ width: "100%" }}
              >
                <AlertTitle>{errorAlertTitle}</AlertTitle>
                {errorAlertMessage}
              </Alert>
            </Snackbar>
          )}
          {updateUserSuccess && updateUserMessage && (
            <Snackbar
              open={snackOpen}
              autoHideDuration={5000}
              onClose={handleSnackClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              sx={{ width: "20%" }}
            >
              <Alert
                onClose={handleSnackClose}
                severity="success"
                sx={{ width: "100%" }}
              >
                <AlertTitle>Success</AlertTitle>
                {updateUserMessage}
              </Alert>
            </Snackbar>
          )}
          {updateUserError && (
            <Snackbar
              open={snackOpen}
              autoHideDuration={5000}
              onClose={handleSnackClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              sx={{ width: "20%" }}
            >
              <Alert
                onClose={handleSnackClose}
                severity="error"
                sx={{ width: "100%" }}
              >
                <AlertTitle>Error</AlertTitle>
                {updateUserError}
              </Alert>
            </Snackbar>
          )}
          {resetPasswordSuccess && resetPasswordMessage && (
            <Snackbar
              open={snackOpen}
              autoHideDuration={5000}
              onClose={handleSnackClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              sx={{ width: "20%" }}
            >
              <Alert
                onClose={handleSnackClose}
                severity="success"
                sx={{ width: "100%" }}
              >
                <AlertTitle>Success</AlertTitle>
                {resetPasswordMessage}
              </Alert>
            </Snackbar>
          )}
          {resetPasswordError && (
            <Snackbar
              open={snackOpen}
              autoHideDuration={5000}
              onClose={handleSnackClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              sx={{ width: "20%" }}
            >
              <Alert
                onClose={handleSnackClose}
                severity="error"
                sx={{ width: "100%" }}
              >
                <AlertTitle>Error</AlertTitle>
                {resetPasswordError}
              </Alert>
            </Snackbar>
          )}
        </Box>
      </Box>
    </Container>
  );
}
